import React from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
  UserInfoCell,
} from '../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../shared/utils/dateUtils';
import { dateFormat, localDataFormat } from '../../../../shared/constants/apiDateFormat';
import { ScanIqCustomerListInfo } from '../../../interfaces/ScanIqCustomerListInfo';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

type CustomerRowProps = {
  customerInfo: ScanIqCustomerListInfo;
};

const CustomerRow = observer(({ customerInfo }: CustomerRowProps) => {
  const { isSuperAdmin } = loggedInUserDataStore;

  const {
    id,
    entityId,
    gymName,
    firstName,
    lastName,
    email,
    phone,
    initialScanDate,
    lastScanDate,
  } = customerInfo;

  return (
    <GridTableRow variant="row">
      <UserInfoCell
        firstName={firstName}
        lastName={lastName}
        email={email}
        phone={phone}
        href={`#!/customer-profile/scan-iq/${entityId}/${id}`}
      />
      {isSuperAdmin && (
        <GridTableCell dataTestId="entity-name-cell">{gymName}</GridTableCell>
      )}
      <GridTableCell dataTestId="registration-date-cell">
        {initialScanDate
          ? getFormattedDate(initialScanDate, localDataFormat, dateFormat)
          : '-'}
      </GridTableCell>
      <GridTableCell dataTestId="registration-date-cell">
        {lastScanDate ? getFormattedDate(lastScanDate, localDataFormat, dateFormat) : '-'}
      </GridTableCell>
    </GridTableRow>
  );
});

export { CustomerRow };
